import Vue from 'vue';

Vue.component('ghl-reimbursement-index', () =>
    import(/* webpackChunkName: 'ghl-reimbursement-index' */ './ghl-reimbursement-index.vue'),
);
